import React from 'react';
import { Icon } from '@doxyme/ui';
import { FormattedMessage } from 'react-intl';
import { TimeConverter } from 'utility/time-converter';
import { AnalyticsHelpers } from '../../analytics.helpers';
import './info-block.scss';
export const InfoBlock = ({ month }) => {
    const cn = AnalyticsHelpers.makeAnalyticsClass('info');
    return (<div className={cn('wrapper')}>
      <div className={cn('item')}>
        <Icon className={cn('icon')} name="laptop"/>
        <div className={cn('text')}>
          <span className={cn('decimal')}>{AnalyticsHelpers.formatNumber(month.totalSessionForOverview)}</span>
          <span className={cn('subtitle')}><FormattedMessage id="account.analytics.usage.info-block.total-sessions"/></span>
        </div>
      </div>
      <div className={cn('item')}>
        <Icon className={cn('icon')} name="clock"/>
        <div className={cn('text')}>
          <span className={cn('decimal')}>{AnalyticsHelpers.formatNumber(TimeConverter.millisecondsToMinutes(month.totalDurationForOverview))}</span>
          <span className={cn('subtitle')}><FormattedMessage id="account.analytics.usage.info-block.session-minutes"/></span>
        </div>
      </div>
      <div className={cn('item')}>
        <Icon className={`${cn('icon')} ${cn('icon--time')}`} name="time"/>
        <div className={cn('text')}>
          <span className={cn('decimal')}>{AnalyticsHelpers.millisToMinutesAndSeconds(month.averageDurationForOverview)}</span>
          <span className={cn('subtitle')}><FormattedMessage id="account.analytics.usage.info-block.avg-session-time"/></span>
        </div>
      </div>
    </div>);
};
